import { User } from "../../../types/User";
import EmployerAnalyticsDossierSummaries from "../components/EmployerAnalyticsDossierSummaries";

const EmployerViewAnalyticsSavingsSummaries = ({ me }: { me: User }) => {
  return (
    <EmployerAnalyticsDossierSummaries
      me={me}
      title="Active Lease Savings"
      subtitle="This is a breakdown of all active leases and estimated savings per employee."
      amountField="annualSavings"
      amountHeader="Annual Savings"
      sortBy="annualSavings"
    />
  );
};

export default EmployerViewAnalyticsSavingsSummaries;
